import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useQueries, useQuery } from 'react-query';
import { Link, useNavigate } from 'react-router-dom';
import Looading from '../../Shared/Looading/Looading';


const AdDoctor = () => {

    const { register, formState: { errors }, handleSubmit } = useForm();
    const [data, setData] = useState();
    const imageHostKey =process.env.REACT_APP_imgbb_key;
    const [createUserEmail, setCreateUserEmail] = useState('');
    const navigate = useNavigate()


    const { data: specialties, isLoading } = useQuery({
        queryKey: ['specialty'],
        queryFn: async () => {
            const res = await fetch('https://denticare-server-sumonhasan55.vercel.app/appointmentSpeciality')
            const data = await res.json();
            return data;
           
        }
    })

    const addAdoctor = data => {
        console.log(data.image[0])
        const image = data.image[0];
        const formData = new FormData();
        formData.append('image', image)
        const url =`https://api.imgbb.com/1/upload?key=${imageHostKey}`
        fetch(url,{
            method:'POST',
            body:formData
        })
        .then(res=>res.json())
        .then(imgData =>{
            console.log(imgData.data.url)
            const doctor = {
                name:data.name,
                email:data.email,
                speciality:data.speciality,
                image:imgData.data.url
            }
            fetch('https://denticare-server-sumonhasan55.vercel.app/doctors',{
                method:'POST',
                headers:{
                    'content-type':'application/json',
                    authorization:`bearer ${localStorage.getItem('accessToken')}`
                },
                body:JSON.stringify(doctor)
            })
            .then(res=>res.json())
            .then(result=>{
                console.log(result);
                alert(`${data.name} is added Successfully`)
                navigate('/dashboard/mnagedoctors')
            })
        })

    }

    if(isLoading){
        return <Looading></Looading>
    }
    return (
        <div>
            <h2 className='text-4xl my-5'>Add A Doctor</h2>
            <form onSubmit={handleSubmit(addAdoctor)} >


                <div className="form-control w-full ">
                    <label className="label">
                        <span className="label-text">Name</span>
                    </label>
                    <input {...register("name",
                        { required: true }
                    )

                    } type="text" placeholder="Doctors Name" className="input input-bordered w-full  " />
                    {errors.name && <p className='text-red-600'>{errors.name?.message}</p>}
                </div>

                <div className="form-control w-full ">
                    <label className="label">
                        <span className="label-text">Email</span>
                    </label>
                    <input {...register("email",
                        { required: true }
                    )

                    } type="email" placeholder="Doctors Email" className="input input-bordered w-full  " />
                    {errors.email && <p className='text-red-600'>{errors.email?.message}</p>}
                </div>

                <div className="form-control w-full ">
                    <label className="label">
                        <span className="label-text">Speciality</span>
                    </label>

                    <select  {...register("speciality",
                        { required: true }
                    )} className="select select-bordered w-full">

                        {
                            specialties?.map(speciality=><option
                            key={speciality._id}
                            value={speciality.name}
                            >{speciality.name}</option>)
                        }
                      
                    </select>

                    <div className="form-control w-full ">
                    <label className="label">
                        <span className="label-text">Email</span>
                    </label>
                    <input {...register("image",
                        { required: true }
                    )

                    } type="file" placeholder="Doctors Email" className="input input-bordered w-full  " />
                    {errors.email && <p className='text-red-600'>{errors.email?.message}</p>}
                </div>
                </div>
                <button className="btn btn-info w-full my-5">Add A Doctor</button>

            </form>
        </div>
    );
};

export default AdDoctor;